export interface AccountModel {
	connectionId: string;
	username: string;
	password: string;
	pin: string;
}
